import React from 'react';
import './management.style.scss';

const Management = () => {
  return (
    <div className="management-container">
      <div className="service-header">
        <h1>Database Management Services</h1>
        <p>Comprehensive database administration and optimization</p>
      </div>

      <div className="service-content">
        <section className="service-overview">
          <h2>Complete Database Administration</h2>
          <p>
            Our database management services ensure your databases run efficiently, 
            securely, and reliably. We provide 24/7 monitoring, performance optimization, 
            and proactive maintenance to keep your data systems operating at peak performance.
          </p>
        </section>

        <section className="service-features">
          <h2>Our Management Services Include:</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🔧</div>
              <h3>Performance Tuning</h3>
              <p>Optimize query performance, indexing strategies, and database configuration for maximum efficiency.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💾</div>
              <h3>Backup & Recovery</h3>
              <p>Comprehensive backup strategies and disaster recovery planning to protect your critical data.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Security Management</h3>
              <p>Database security hardening, access control, and compliance with industry standards.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>24/7 Monitoring</h3>
              <p>Continuous monitoring with real-time alerts for proactive issue resolution.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Capacity Planning</h3>
              <p>Strategic planning for database growth and resource allocation.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔄</div>
              <h3>Maintenance & Updates</h3>
              <p>Regular maintenance, patches, and version upgrades with minimal downtime.</p>
            </div>
          </div>
        </section>

        <section className="technology-stack">
          <h2>Supported Database Technologies</h2>
          <div className="tech-grid">
            <div className="tech-item">MySQL</div>
            <div className="tech-item">PostgreSQL</div>
            <div className="tech-item">SQL Server</div>
            <div className="tech-item">Oracle</div>
            <div className="tech-item">MongoDB</div>
            <div className="tech-item">Redis</div>
            <div className="tech-item">Cassandra</div>
            <div className="tech-item">Amazon RDS</div>
          </div>
        </section>

        <section className="contact-section">
          <h2>Need Database Management Support?</h2>
          <p>Contact us today to discuss your database management requirements.</p>
          <button className="contact-btn">Get Started</button>
        </section>
      </div>
    </div>
  );
};

export default Management;